import React from 'react';
import clsx from 'clsx';

import { createStyles } from "./styles";

var RightSidebar = function RightSidebar(_ref)




{var _ref$sidebarStyles = _ref.sidebarStyles,sidebarStyles = _ref$sidebarStyles === void 0 ? '' : _ref$sidebarStyles,_ref$width = _ref.width,width = _ref$width === void 0 ? '' : _ref$width,children = _ref.children,_ref$isOpen = _ref.isOpen,isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen;
  var classes = createStyles({ width: width });

  return /*#__PURE__*/(
    React.createElement("section", {
      className: clsx(classes.sidebar, isOpen ? classes.sidebarOpened : classes.sidebarClosed) }, /*#__PURE__*/

    React.createElement("div", {
      className: clsx(
      classes.sidebarContent,
      isOpen ? classes.sidebarContentVisible : classes.sidebarContentHidden,
      sidebarStyles) },


    children)));



};

export default RightSidebar;
//# sourceMappingURL=index.js.map